import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { POST_LOGIN_REDIRECT_KEY, isSafeInternalPath } from '../utils/post-login-redirect';

export function LoginPage() {
  const { loginWithGoogle, isLoading } = useAuth();
  const [searchParams] = useSearchParams();

  const handleLogin = () => {
    // Stash the return-to path across the Google OAuth redirect — the
    // callback page navigates there after the tokens are stored.
    const next = searchParams.get('next');
    if (isSafeInternalPath(next)) {
      sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, next);
    } else {
      sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    }
    void loginWithGoogle();
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary-900 via-primary-800 to-primary-700">
      <div className="text-center bg-white rounded-2xl shadow-2xl p-10 max-w-sm w-full mx-4">
        <img src="/logo.png" alt="NP Events & Productions" className="h-20 w-20 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-1">NP Events &amp; Productions</h1>
        <p className="text-sm text-gray-500 mb-8">Sign in to manage your events</p>
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="w-full flex items-center justify-center gap-3 px-6 py-3 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="#4285F4"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="#34A853"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              fill="#FBBC05"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="#EA4335"
            />
          </svg>
          {isLoading ? 'Signing in...' : 'Sign in with Google'}
        </button>
      </div>
    </div>
  );
}
